export const breakpoints = {
  tablet: '1000px',
  mobile: '44rem',
  mobileMenu: '900px',
};

export const media = {
  tablet: `@media (max-width: ${breakpoints.tablet})`,
  mobile: `@media (max-width: ${breakpoints.mobile})`,
  mobileMenu: `@media (max-width: ${breakpoints.mobileMenu})`,
};

